// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Author } from './author';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

export interface Book extends Model {
  authors: Author[];
  title: string;
  description: string;
  isbn: string;
  publicationDate: Date;
  publisher: string;
  pages?: number;
  genres?: string[];
}

export const BookConfig: EntityConfigTemplate = {
  meta: { entityName: "book", entityPluralName: "books", titleField: 'title', view: false}, //view:false is used to hide this attr from views
  isbn: { type: 'text', title: "ISBN" },
  authors: { type:'relation' , isForeignKey: true,  view: { list: false }},
  authorsValue: { title: "Author", valuePrep: (_cell_, row) => !isEmpty(row?.authors) ? row.authors.map((author)=>`${author?.firstName} ${author?.lastName}`).join(", ") : '' },
  title: {type: 'text'},
  description: { title: "Summary", type:'text'},
  publicationDate: { title: "Publication Date", type: 'date' },
  publisher: { view: { list: false }, type: 'text' },
  pages: { title: "Pages", type: 'number', default: "Unknown" },
  genres: { type: 'text', view: { list: false }, default: [] },
  rating: { type: 'number', title: "Score"},
}

export const BookFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Book Details",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              title: "Book Details",
              rows: [
                {
                  fields: [
                    { name: "title", label: "Title", type: "text", required: true, size: "col-6" },
                    { name: "isbn", label: "ISBN", type: "text", required: true, size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "authors", label: "Authors", type: "selectRelation", multiSelect: true, entityName: "author", required: false, size: "col-6" },
                    { name: "publisher", label: "Publisher", type: "text", size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", size: "col-12" },
                  ] 
                },
                {
                  fields: [
                    { name: "genres", label: "Genres", type: "text", default: [], size: "col-4" },
                    { name: "publicationDate", label: "Publication Date", type: "date", size: "col-4" },
                  ] 
                },
                {
                  fields: [
                    { name: "rating", label: "Rating", type: "number", size: "col-6" },
                    { name: "pages", label: "Pages", type: "number", size: "col-4" },
                  ]
                }

              ],
            }
          ],
        },
      ]
    },{
      title: "Authors",
      columns: [
        {
          size: "col-12",
          type: "tableRelation",
          entityName: "author",
        },
      ],
    }
  ]
}
export abstract class BookData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Book[]>;
  abstract get(id: string): Observable<Book>;
  abstract update(Book: Book): Observable<Book>;
  abstract create(Book: Book): Observable<Book>;
  abstract delete(id: string): Observable<boolean>;
  
}